import "./App.css";

import Layout from "./Layout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Mission from "./pages/Mission";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Philosophy from "./pages/Philosophy";
import Work from "./pages/Work";
import Services from "./pages/Services";
import CaseStudies from "./pages/CaseStudies";
import Insights from "./pages/Insights";
import FAQ from "./pages/FAQ";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<Layout />}
          >
            <Route
              index
              element={<Home />}
            />
            <Route path="about" element={<About />} />
            <Route path="services" element={<Services />} />
            <Route path="case-studies" element={<CaseStudies />} />
            <Route path="insights" element={<Insights />} />
            <Route path="faq" element={<FAQ />} />
            <Route
              path="contact"
              element={<Contact />}
            />
            <Route
              path="philosophy"
              element={<Philosophy />}
            />
            <Route
              path="work"
              element={<Work />}
            />
            <Route
              path="*"
              element={<Mission />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
